<template>
  <div class="common-wrapper">
    <h3>{{section.detail.name}}</h3>
    <div class="wrapper">
        <div class="number-container" v-for="(item, index) in section.detail.links" :key="item.key">
        <span class="number" :id="'value-'+index">{{item.name}}</span>
        <span class="desc">{{item.desc}}</span>
        </div>
    </div>
    <p class="footnote">Updated on Aug 2021</p>
  </div>
</template>
<script>
export default {
  props: {
    section: Object,
  },
  mounted() {
    const items = (this.section && this.section.detail && this.section.detail.links) || [];
    items.forEach((_, index) => this.animateValue(`value-${index}`, 1, 5000));
  },
  methods: {
    animateValue(id, start, duration) {
      const obj = document.getElementById(id);
      if (!obj) return;
      const original = obj.innerHTML.trim();
      const match = original.match(/^(\d+)(.*)$/);
      if (!match) return;
      const end = parseInt(match[1], 10);
      const suffix = match[2];
      if (Number.isNaN(end) || start >= end) {
        obj.innerHTML = original;
        return;
      }
      const range = end - start;
      const stepTime = Math.max(1, Math.floor(duration / range));
      let current = start;
      obj.innerHTML = `${current}${suffix}`;
      const timer = setInterval(() => {
        current += 1;
        obj.innerHTML = `${current}${suffix}`;
        if (current >= end) clearInterval(timer);
      }, stepTime);
    },
  },
};
</script>
<style lang="scss" scoped>
.common-wrapper {
  .footnote {
    padding-top: size(40);
    font-size: size(12);
    color: grey;
  }
}
</style>
